const key=(kind,uid)=>uid?`tradelog-${kind}:${uid}`:null;
export function readTradeDraft(uid,now=Date.now()){
  try{
    const draft=JSON.parse(localStorage.getItem(key('trade-draft',uid))||'null');
    // A draft can begin with notes or another field before a market is chosen.
    // Validate its shape and owner/expiry, rather than requiring trade fields.
    const data=draft?.data,valid=data&&typeof data==='object'&&!Array.isArray(data)&&Object.keys(data).length>0;
    return uid&&draft?.ts<=now&&now-draft.ts<48*3600000&&valid?data:null;
  }catch{return null;}
}
export function saveTradeDraft(uid,trade,now=Date.now()){
  if(!uid)throw new Error('Sign in to keep a draft.');
  const clean=image=>image?.src?.startsWith('data:')?null:image;
  localStorage.setItem(key('trade-draft',uid),JSON.stringify({ts:now,data:{...trade,mainChart:clean(trade.mainChart),images:(trade.images||[]).map(clean)}}));
}
export function clearTradeDraft(uid){if(uid)localStorage.removeItem(key('trade-draft',uid));}
export function readInsightHistory(uid){
  if(!uid)return [];
  try{const data=JSON.parse(localStorage.getItem(key('ai-history',uid))||'[]');return Array.isArray(data)?data.slice(0,20):[];}catch{return [];}
}
export function writeInsightHistory(uid,history){
  if(!uid)return false;
  try{localStorage.setItem(key('ai-history',uid),JSON.stringify(history.slice(0,20)));return true;}catch{return false;}
}
// Older unassigned caches are intentionally retained on this device but never
// attached to whichever person signs in next. Cloud records remain unchanged.
